/* tslint:disable */

/**
 */
export class MembershipFormApp {
    data_hash?: string;
    timestamp?: string;
}
